import React from 'react'
import LabeledValue from '../../../../components/common/LabeledValue'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'
import { getVacationBidAwareTableProps } from './vacationBidOverlapDisplay'
import RightPanel from './RightPanel'
import CurrentRequestSection from './CurrentRequestSection'
import HistorySection from './HistorySection'

interface RetractedViewProps {
  data: TimeOffRequestDetails
  tableRows: any[]
  highlightedDates: string[]
  handlePrint?: () => void

}

const RetractedView: React.FC<RetractedViewProps> = ({ data, tableRows, highlightedDates, handlePrint }) => (
  <div>
    <h1 className="h1">Time Off Request Retraction Approved</h1>
    <div className="flex flex-col mobile:gap-4 tablet:gap-6 desktop:gap-8 desktop:flex-row">
      <div className="flex-1">
        {data.retractionApprovedOn && (
          <div className="mb-4">
            <LabeledValue label="Retraction Approved On" value={data.retractionApprovedOn} />
          </div>
        )}
        {data.authorizedApprover && (
          <div className="mb-4">
            <LabeledValue label="Authorized Approver" value={data.authorizedApprover} />
          </div>
        )}
        {(data.requestRank != null || isVacationBid(data)) && (
          <div className="mb-4">
            <LabeledValue label="Request Rank" value={data.requestRank == null ? 'NA' : String(data.requestRank)} />
          </div>
        )}
        <div className="mb-4">
          <LabeledValue label="Approver Comments" value={data.approverComments || ''} />
        </div>
      </div>
      <RightPanel data={data} handlePrint={handlePrint} />
    </div>
    <div className="mt-6!"><hr className="-variation-1" /></div>
    {data.history && data.history.length > 0 && <HistorySection history={data.history} />}
      <CurrentRequestSection {...getVacationBidAwareTableProps(tableRows, isVacationBid(data))} highlightedDates={highlightedDates} />
  </div>
)

export default RetractedView
